(function($) {

    $('#yogaTips').slick({
		arrows: false,
		dots: true,
        appendDots: '#tipSliderDots',
        infinate: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst:true,
        responsive: [
            {
                breakpoint: 767,
                settings: "unslick"
            }
        ]
    });
    
    $('#yogaPoseSlider').slick({
		arrows: false,
		dots: true,
        appendDots: '#yogaPoseDots',
        infinate: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst:true,
        responsive: [
            {
                breakpoint: 767,
                settings: "unslick"
            }
        ]
    });

    $('.recommendedProductSlider').on('init', function(event, slick){
        $('.recommendedProductSlider').each(function(){

            var dots = $(this).find('.slick-dots li');

            console.log(dots.length);

            if( dots.length == 1 || dots.length == 0 ) {
                $(this).find('.slick-dots').hide();
            }

        });
    });
    
    $('.recommendedProductSlider').slick({
		arrows: true,
		dots: true,
        fade: true,
        infinate: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst:true
    });
    

    $('.suggestedFoodCol').each(function() {

        var imgs = $(this).find('img');
        var dots = $(this).find('.slick-dots')

        if( imgs.length == 1 ) {
            $(dots).hide();
        }

    });

    // the pulse component
    $(".pulse").each(function() {
        var issueWidth = $(this).find(".issue p").outerWidth();
        var top = (issueWidth/2)-10;
        var left = top - 5;
        
        $(this).find(".issue").css({'top': top, 'left': '-'+left+'px'});
    });


    // Sleep hub // 

    if( $(".floatingBox").length > 0 ) {
        var fb = $(".floatingBox");
        var fbHeight = $(".floatingBox").outerHeight();
        var fbHeightHalf = fbHeight/2;
        $(fb).css('top', '-'+fbHeightHalf+'px');
    }

    $('.tipsSlider').slick({
		arrows: false,
		dots: true,
        fade: false,
        dotsClass: 'sliderDotsGrid',
        infinate: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst:true,
        responsive: [
            {
                breakpoint: 767,
                settings: "unslick"
            }
        ]
    });

    $('.strategiesSlider').slick({
		arrows: false,
		dots: true,
        fade: false,
        dotsClass: 'sliderDotsGridStrat',
        infinate: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst:true,
        responsive: [
            {
                breakpoint: 767,
                settings: "unslick"
            }
        ]
    });
    

    
})(jQuery);